import { FC } from 'react'
import {
  OverlayParagraph,
  OverlaySubtitle
} from 'linkdrop-ui'
import { PopupContentWithImage, ImageStyled } from './styled-components'
import WalletSmall from 'images/wallet-small.png'
import BoxSmall from 'images/box-small.png'

const PopupContents: FC = () => {
  return <>
    <OverlayParagraph>
      A crypto wallet is needed to store and manage cryptocurrency in a secure and convenient way. It allows users to view their balance, send and receive cryptocurrency, and track their transaction history. In addition, many crypto wallets allow users to connect their wallet to decentralized applications (dApps) and use their cryptocurrency to interact with the dApps in various ways.
    </OverlayParagraph>
    <PopupContentWithImage>
      <ImageStyled src={BoxSmall} />
      <div>
        <OverlaySubtitle>A Home for your Digital Assets</OverlaySubtitle>
        <OverlayParagraph>
          Wallets are used to send, receive, store, and display digital assets like Ethereum and NFTs
        </OverlayParagraph>
      </div>
    </PopupContentWithImage>

    <PopupContentWithImage>
      <ImageStyled src={WalletSmall} />
      <div>
        <OverlaySubtitle>A New Way to Log In</OverlaySubtitle>
        <OverlayParagraph>
          Instead of creating new accounts and passwords on every website, just connect your wallet
        </OverlayParagraph> 
      </div>
    </PopupContentWithImage>
  </>
}

export default PopupContents